import { useState } from 'react';
import type { DatoveSchrankyDatovaZpravaDto } from '@gov-nx/api';
import { hasProperty, prop } from '@gov-nx/core/types';
import { DataBoxFolderType } from '../providers/DataBoxes.types';
import { DataBoxListStatesType } from '../providers/MessageListContext.types';
import { getMessageParams } from '../utils/message';

interface MessagesSelectProps {
	dataBoxId: string;
	folderType: DataBoxFolderType;
	listState: DataBoxListStatesType;
	messageList: DatoveSchrankyDatovaZpravaDto[];
}

export function useMessagesSelect({
	dataBoxId,
	folderType,
	listState,
	messageList,
}: MessagesSelectProps) {
	const [selectedMessageList, setSelectedMessageList] = useState<number[]>([]);
	const [isAllSelected, setIsAllSelected] = useState(false);

	const showCheckboxes = ![
		DataBoxListStatesType.List,
		DataBoxListStatesType.Search,
	].includes(listState);

	const updateSelectedMessageList = (id: number) => {
		const deselecting = selectedMessageList.includes(id);
		if (deselecting) {
			setSelectedMessageList(selectedMessageList.filter((item) => item !== id));
			setIsAllSelected(false);
		} else {
			setSelectedMessageList([...selectedMessageList, id]);
			setIsAllSelected(messageList.length === selectedMessageList.length + 1);
		}
	};

	const updateAllMessagesSelection = (check: boolean) => {
		if (check) {
			setSelectedMessageList(
				messageList
					.filter(hasProperty('datovaZpravaId'))
					.filter((message) => {
						if (message.datumArchivace) return false;
						if (folderType !== DataBoxFolderType.Received) return true;
						return !getMessageParams({ message, dataBoxId, folderType })
							.isUnread;
					})
					.map(prop('datovaZpravaId'))
			);
			setIsAllSelected(true);
		} else {
			setSelectedMessageList([]);
			setIsAllSelected(false);
		}
	};

	return {
		showCheckboxes,
		selectedMessageList,
		setSelectedMessageList,
		updateSelectedMessageList,
		updateAllMessagesSelection,
		isAllSelected,
		isPartialySelected: selectedMessageList.length > 0 && !isAllSelected,
		setIsAllSelected,
	};
}
